"use strict";

var _regeneratorRuntime = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var graphql_to_sparql_1 = require("graphql-to-sparql");

var jsonld_context_parser_1 = require("jsonld-context-parser");

var sparqljson_to_tree_1 = require("sparqljson-to-tree");
/**
 * A GraphQL-LD client.
 *
 * Typical usage:
 * ```
 * const client = new Client({ context, queryEngine });
 * const { data } = await client.query({ query: `{ books { name author { name } } }` });
 * ```
 */


var Client =
/*#__PURE__*/
function () {
  function Client(args) {
    _classCallCheck(this, Client);

    this.context = (args.contextParser || new jsonld_context_parser_1.ContextParser()).parse(args.context, {
      baseIri: args.baseIri
    });
    this.queryEngine = args.queryEngine;
    this.graphqlToSparqlConverter = args.graphqlToSparqlConverter || new graphql_to_sparql_1.Converter({
      dataFactory: args.dataFactory,
      requireContext: true
    });
    this.sparqlJsonToTreeConverter = args.sparqlJsonToTreeConverter || new sparqljson_to_tree_1.Converter({
      dataFactory: args.dataFactory,
      materializeRdfJsTerms: true
    });
  }
  /**
   * Execute a GraphQL-LD query.
   *
   * There are three ways of invoking this methods:
   * 1. with a GraphQL query string and optional variables:
   *    `client.query({ query: `{...}`, variables: { varName: 123 } })`
   * 2. with a parsed GraphQL query and optional variables:
   *    `client.query({ query: gql`{...}`, variables: { varName: 123 } })`
   * 3. with a SPARQL algebra object and a singularizeVariables object
   *    `client.query({ sparqlAlgebra, singularizeVariables })`
   *    This corresponds to the result of {@link Client#graphQlToSparql}.
   *
   * @param {QueryArgs} args Query+variables, or SPARQL algebra+singularize variables.
   * @return {Promise<ExecutionResult>} A promise resolving to a GraphQL result.
   */


  _createClass(Client, [{
    key: "query",
    value: function query(args) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var _ref, sparqlAlgebra, singularizeVariables, sparqlJsonResult, data;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!('query' in args)) {
                  _context.next = 6;
                  break;
                }

                _context.next = 3;
                return this.graphQlToSparql({
                  query: args.query,
                  variables: args.variables
                });

              case 3:
                _context.t0 = _context.sent;
                _context.next = 7;
                break;

              case 6:
                _context.t0 = args;

              case 7:
                _ref = _context.t0;
                sparqlAlgebra = _ref.sparqlAlgebra;
                singularizeVariables = _ref.singularizeVariables;
                _context.next = 12;
                return this.queryEngine.query(sparqlAlgebra, args.queryEngineOptions);

              case 12:
                sparqlJsonResult = _context.sent;
                // Convert SPARQL response to GraphQL response
                data = this.sparqlJsonToTreeConverter.sparqlJsonResultsToTree(sparqlJsonResult, {
                  singularizeVariables: singularizeVariables
                });
                return _context.abrupt("return", {
                  data: data
                });

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
    /**
     * Convert a GraphQL query to SPARQL algebra and a singularize variables object.
     * @param {string | DocumentNode} query
     * @param {{[p: string]: any}} variables
     * @return {Promise<IGraphQlToSparqlResult>}
     */

  }, {
    key: "graphQlToSparql",
    value: function graphQlToSparql(_ref2) {
      var query = _ref2.query,
          variables = _ref2.variables;
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var singularizeVariables, options, sparqlAlgebra;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                singularizeVariables = {};
                options = {
                  singularizeVariables: singularizeVariables,
                  variablesDict: {}
                };
                _context2.t0 = this.graphqlToSparqlConverter;
                _context2.t1 = query;
                _context2.next = 6;
                return this.context;

              case 6:
                _context2.t2 = _context2.sent;
                _context2.t3 = options;
                _context2.next = 10;
                return _context2.t0.graphqlToSparqlAlgebra.call(_context2.t0, _context2.t1, _context2.t2, _context2.t3);

              case 10:
                sparqlAlgebra = _context2.sent;
                return _context2.abrupt("return", {
                  sparqlAlgebra: sparqlAlgebra,
                  singularizeVariables: singularizeVariables
                });

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
  }]);

  return Client;
}();

exports.Client = Client;